import catalogJson from "./mannequinCatalog.json";
import manifestJson from "./mannequinManifest.json";

export interface MannequinCatalogVariant {
  id: string;
  slug: string;
  shortLabel: string;
  modelName: string;
  hasNormalMap: boolean;
}

export interface MannequinCatalog {
  defaultModelId: string;
  freeModelIds: string[];
  variants: MannequinCatalogVariant[];
}

export interface MannequinAssetContract {
  path: string;
  present: boolean;
  sizeBytes: number | null;
}

export interface MannequinNormalContract extends MannequinAssetContract {
  expected: boolean;
}

export interface MannequinBuildContract {
  schemaVersion: number;
  variant: string;
  modelId: string;
  generatedAt: string | null;
  workspaceFingerprint: string | null;
  bindingsHash: string | null;
  sourceHashes: Record<string, string | null>;
  vertexCount: number | null;
  bodyVertexCount: number | null;
  headVertexCount: number | null;
  boneCount: number | null;
  headSplitSucceeded: boolean;
}

export interface MannequinManifestVariant {
  id: string;
  slug: string;
  runtimeReady: boolean;
  glb: MannequinAssetContract;
  normal: MannequinNormalContract;
  build: MannequinBuildContract | null;
}

export interface MannequinManifest {
  schemaVersion: number;
  generatedAt: string | null;
  bindingsHash: string | null;
  availableModelIds: string[];
  variants: MannequinManifestVariant[];
}

export const MANNEQUIN_CATALOG =
  catalogJson as unknown as Readonly<MannequinCatalog>;
export const MANNEQUIN_MANIFEST =
  manifestJson as unknown as Readonly<MannequinManifest>;

export const MANNEQUIN_VARIANTS = MANNEQUIN_CATALOG.variants;
export const MANNEQUIN_MODEL_IDS = MANNEQUIN_VARIANTS.map((variant) => variant.id);
export type MannequinModelId = string;

export const DEFAULT_MANNEQUIN_MODEL_ID = MANNEQUIN_CATALOG.defaultModelId;
export const FREE_MANNEQUIN_MODEL_IDS = new Set(MANNEQUIN_CATALOG.freeModelIds);

const _variantsById = new Map(MANNEQUIN_VARIANTS.map((variant) => [variant.id, variant]));
const _variantsBySlug = new Map(
  MANNEQUIN_VARIANTS.map((variant) => [variant.slug, variant]),
);
const _manifestById = new Map(
  MANNEQUIN_MANIFEST.variants.map((variant) => [variant.id, variant]),
);

export function getMannequinVariantById(id: string): MannequinCatalogVariant | undefined {
  return _variantsById.get(id);
}

export function getMannequinVariantBySlug(
  slug: string,
): MannequinCatalogVariant | undefined {
  return _variantsBySlug.get(slug);
}

export function getMannequinManifestEntry(
  id: string,
): MannequinManifestVariant | undefined {
  return _manifestById.get(id);
}
